import { lazy, Suspense } from "react";

// The highlighter pulls react-markdown + highlight.js (already in the lazy
// Markdown chunk); load it on demand so it never lands in the eager bundle.
const HighlightedCode = lazy(() =>
  import("./HighlightedCode").then((m) => ({ default: m.HighlightedCode })),
);

/**
 * Scrollable source view for the Canvas. Syntax highlighting reuses the chat
 * code-block pipeline (monochrome `.hljs-*` weight/italic, no colour — matching
 * DESIGN + the in-chat blocks). While the highlighter loads, the raw text shows
 * with identical layout so there's no flash.
 */
export function CanvasCodeView({ code, language }: { code: string; language?: string }) {
  return (
    <div className="chat-code canvas-code h-full overflow-auto bg-paper">
      <Suspense
        fallback={
          <pre>
            <code>{code}</code>
          </pre>
        }
      >
        <HighlightedCode code={code} language={language} />
      </Suspense>
    </div>
  );
}
